import { withDeepApiConfig } from '@deepcloud/api-base'
import {
  AdminAPI,
  ChatAPI,
  JiraSearchAPI,
  KbAPI,
  MetadataAPI,
  NotificationsAPI,
  OperationsAPI,
  TicketAPI,
  UsersAPI,
  WishAPI,
} from '../../v1'
import type { HttpClient } from '@deepcloud/http-client'
import type { CreateAbaSupportHttpClientOptions } from '../types'

function createAPIV1(abaSupportHttpClient: HttpClient) {
  return {
    admin: new AdminAPI(abaSupportHttpClient),
    chat: new ChatAPI(abaSupportHttpClient),
    jiraSearch: new JiraSearchAPI(abaSupportHttpClient),
    kb: new KbAPI(abaSupportHttpClient),
    metadata: new MetadataAPI(abaSupportHttpClient),
    notifications: new NotificationsAPI(abaSupportHttpClient),
    operations: new OperationsAPI(abaSupportHttpClient),
    ticket: new TicketAPI(abaSupportHttpClient),
    users: new UsersAPI(abaSupportHttpClient),
    wish: new WishAPI(abaSupportHttpClient),
  }
}

function createAbaSupportAPIV1({
  httpClient,
  ...config
}: CreateAbaSupportHttpClientOptions) {
  const abaSupportHttpClient = withDeepApiConfig(httpClient, config)

  return {
    abaSupportHttpClient,
    ...createAPIV1(abaSupportHttpClient),
  }
}

export { createAPIV1, createAbaSupportAPIV1 }
